import React from 'react';
import { Alert, Box, Notification } from '@wix/cli-ui-kit';
import { Trans } from '@wix/cli-i18n';
import { useBackendComponents } from '../../../backend/useBackendComponents.js';

export const Warnings = () => {
  const { backendComponentsByType } = useBackendComponents();

  if (backendComponentsByType.Event.length === 0) {
    return null;
  }

  return (
    <Box flexDirection="column" paddingBottom={1}>
      <Notification>
        <Alert type="warning">
          <Trans i18nKey="release_command.confirm_version_events_warning" />
        </Alert>
      </Notification>
    </Box>
  );
};
